import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
    return (
        <Card className="quote-card-view">
            <Card.Body>
                <blockquote className="blockquote mb-0">
                    <p style={{ textAlign: "left" }}>
                        I'm a software engineer with experience in building scalable and efficient applications.
                        I have a passion for solving complex problems, optimizing performance, and leveraging modern
                        technologies to deliver high-quality software solutions.
                        <br />
                        <br />
                        A little about my professional background:
                    </p>
                    <ul>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Developing full-stack applications
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Architecting scalable backend systems
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Working with cloud infrastructure and DevOps
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Building microservices and event-driven systems
                        </li>
                    </ul>
                    <br />
                    <p style={{ textAlign: "left" }}>
                        Technologies & Tools I Use:
                    </p>
                    <ul>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Languages: TypeScript, JavaScript, Java
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Frontend: React, Angular
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Backend: Express.js, Spring Boot
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> DevOps & Cloud: Docker, AWS, Kubernetes
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Messaging & Streaming: Kafka
                        </li>
                        <li className="about-activity">
                            <i className="far fa-hand-point-right"></i> Build & Dependency Management: Maven
                        </li>
                    </ul>
                </blockquote>
            </Card.Body>
        </Card>
    );
}

export default AboutCard;
